// frontend_react/src/pages/kitchen/KitchenScreen.jsx

import React, { useEffect, useState } from "react";
import { getSocket, joinRoom } from "../../services/socket";
import { useAdminScope } from "../../context/AdminScopeContext";

function KitchenScreen() {
  const [tickets, setTickets] = useState([]);
  const { selectedCompanyUuid } = useAdminScope();

  useEffect(() => {
    setTickets([]);

    if (!selectedCompanyUuid) return;

    const socket = getSocket();
    const room = `kitchen:${selectedCompanyUuid}`;

    joinRoom(room);

    const onNewTicket = (data) => {
      if (data.destination !== "kitchen") return;
      if (data.company_uuid && data.company_uuid !== selectedCompanyUuid) return;

      try {
        new Audio("/ding.mp3").play();
      } catch {
        console.warn("Audio blocked by browser");
      }

      setTickets((prev) => [
        {
          ...data,
          status: "pending",
          createdAt: Date.now(),
        },
        ...prev,
      ]);
    };

    socket.on("kitchen:new_ticket", onNewTicket);

    return () => {
      socket.off("kitchen:new_ticket", onNewTicket);
    };
  }, [selectedCompanyUuid]);

  const updateStatus = (uuid, newStatus) => {
    setTickets((prev) =>
      prev.map((t) => (t.uuid === uuid ? { ...t, status: newStatus } : t))
    );
  };

  const getElapsed = (createdAt) => {
    const diff = Math.floor((Date.now() - createdAt) / 1000);
    const min = Math.floor(diff / 60);
    const sec = diff % 60;
    return `${min}:${sec.toString().padStart(2, "0")}`;
  };

  const columns = {
    pending: tickets.filter((t) => t.status === "pending"),
    preparing: tickets.filter((t) => t.status === "preparing"),
    ready: tickets.filter((t) => t.status === "ready"),
  };

  return (
    <div style={{ background: "#111", minHeight: "100vh", color: "white", padding: 20 }}>
      <h1>🍽️ Cuisine Live</h1>

      <div style={{ display: "flex", gap: 20 }}>
        <Column title="🟡 À préparer" tickets={columns.pending} getElapsed={getElapsed}>
          {(ticket) => (
            <button onClick={() => updateStatus(ticket.uuid, "preparing")}>
              ▶️ Démarrer
            </button>
          )}
        </Column>

        <Column title="🔵 En cours" tickets={columns.preparing} getElapsed={getElapsed}>
          {(ticket) => (
            <button onClick={() => updateStatus(ticket.uuid, "ready")}>
              ✅ Terminer
            </button>
          )}
        </Column>

        <Column title="🟢 Prêt" tickets={columns.ready} getElapsed={getElapsed}>
          {(ticket) => (
            <button onClick={() => updateStatus(ticket.uuid, "served")}>
              🧾 Servi
            </button>
          )}
        </Column>
      </div>
    </div>
  );
}

function Column({ title, tickets, children, getElapsed }) {
  return (
    <div style={{ flex: 1 }}>
      <h2>{title}</h2>

      {tickets.map((ticket) => (
        <div
          key={ticket.uuid}
          style={{
            background: "#1e1e1e",
            padding: 15,
            borderRadius: 10,
            marginBottom: 15,
            boxShadow: "0 0 10px rgba(0,0,0,0.5)",
          }}
        >
          <h3>Table {ticket.table_number}</h3>
          <p>#{ticket.ticket_number}</p>

          <p style={{ color: "#aaa", fontSize: 12 }}>
            ⏱ {getElapsed(ticket.createdAt)}
          </p>

          <ul>
            {(ticket.lines || []).map((line, idx) => (
              <li key={`${ticket.uuid}-${idx}`}>
                {line.quantity} × {line.name}
              </li>
            ))}
          </ul>

          <div style={{ marginTop: 10 }}>{children(ticket)}</div>
        </div>
      ))}
    </div>
  );
}

export default KitchenScreen;